var $ec8dd13b968e5322$exports = {};
$ec8dd13b968e5322$exports = {
    "alert": `Advarsel`,
    "dismiss": `Luk`
};


export {$ec8dd13b968e5322$exports as default};
//# sourceMappingURL=da-DK.module.js.map
